import { DownloadButton } from '@anytag/shared-atoms';
import { ListWithPagination } from '@anytag/shared-molecules';
import { convertOrderToORDER, getOffset, getRestApiUrl, getValuableVariables } from '@anytag/shared-utils';
import { useDownloadFile, useParamsSearch } from '@anytag/shared-hooks';
import { SocialPostType, useAllInfluencerAccountPostsQuery } from '@anytag/graphql';
import {
  ProfilePostsCount,
  ProfilePostsFilter,
  InfluencerScrapingPostsList,
  InfluencerScrapingPostsListSearchSchemaType
} from '@anytag/shared-organisms';
import { useInitialInfluencerPostsListWithName } from '../hooks';

export const InfluencerScrapingPosts = () => {
  const { downloading, handleDownloadFile } = useDownloadFile();
  const { influencerId, mainSocialAccountId } = useInitialInfluencerPostsListWithName();
  const { page, limit, sort, filter, setFilter } = useParamsSearch<InfluencerScrapingPostsListSearchSchemaType>();

  const socialPostType = (filter.type || SocialPostType.INSTAGRAM) as SocialPostType;

  const { data, previousData, loading } = useAllInfluencerAccountPostsQuery({
    skip: !influencerId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      socialPostType,
      socialAccountId: mainSocialAccountId,
      keyword: filter.keyword,
      offset: getOffset(page, limit),
      orderBy: { field: sort.field, order: convertOrderToORDER(sort.order) }
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allInfluencerAccountPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} />

      <ProfilePostsCount count={totalRecords}>
        <DownloadButton
          loading={downloading}
          onClick={() =>
            handleDownloadFile({
              filenamePrefix: 'scraping_posts',
              url: getRestApiUrl(`influencer/social_post/${mainSocialAccountId}/${socialPostType}/csv/`)
            })
          }
        />
      </ProfilePostsCount>

      <InfluencerScrapingPostsList
        loading={loading}
        influencerId={influencerId}
        socialPostType={socialPostType}
        data={result?.allInfluencerAccountPosts || []}
      />
    </ListWithPagination>
  );
};
